import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Field, reduxForm} from "redux-form";
import Checkbox from "../../components/Checkbox";
import {putFormData} from "../../actions/FormData";
import HintWrapper from "../../components/HintWrapper";
import FadingTransitionGroup from "../../components/FadingTransitionGroup";
import {toggleSelectionTriggered} from "../../actions/Util";
import {DOMAIN_TYPE_DEV} from "../../constants/General";
import {removeAllDomainsFromCart} from "../../actions/Cart";
import {initTestingForm} from "../../actions/Testing";

function mapStateToProps(state) {
    return {
        isTestingInCart: state.cart.testing
    };
}

function mapDispatchToProps(dispatch) {
    return {
        selectTestingValue: (e, testingSelected) => {
            setTimeout(() => {
                dispatch(putFormData()).then(() => {
                    if (testingSelected) {
                        dispatch(removeAllDomainsFromCart());
                        dispatch(toggleSelectionTriggered('domainType', DOMAIN_TYPE_DEV))
                    }
                })
            }, 50)
        },
        initTestingForm: () => {
            dispatch(initTestingForm());
        }
    };
}

class TestingGroup extends Component {

    componentDidMount() {
        this.props.initTestingForm()
    }

    render() {
        return (
            <div className="configuration-step__custom-group configuration-step__custom-group--testing">
                <Field
                    onChange={this.props.selectTestingValue}
                    name="testing"
                    type="checkbox"
                    component={Checkbox}
                    label="Noch unsicher? Teste uns als Neukunde für 10 Tage und überzeug dich selbst! (Das Paket kann während des Testzeitraums jederzeit per Klick gekündigt werden.)"
                />
                <FadingTransitionGroup>
                    {this.props.isTestingInCart ? <HintWrapper theme={"blue"} content={"Während des Testzeitraums können keine Domains und E-Mail Adressen genutzt werden."}/> : null}
                </FadingTransitionGroup>
            </div>
        );
    }
}

TestingGroup = reduxForm({form: 'testing'})(TestingGroup)
TestingGroup = connect(mapStateToProps, mapDispatchToProps)(TestingGroup)

export default TestingGroup



/** WEBPACK FOOTER **
 ** ./src/containers/configuration/TestingGroup.js
 **/